import { render, staticRenderFns } from "./BrowseBuildingOwner.vue?vue&type=template&id=cd3f4756&scoped=true&"
import script from "./BrowseBuildingOwner.vue?vue&type=script&lang=js&"
export * from "./BrowseBuildingOwner.vue?vue&type=script&lang=js&"
import style0 from "./BrowseBuildingOwner.vue?vue&type=style&index=0&id=cd3f4756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3f4756",
  null
  
)

export default component.exports